/**
 * @generated SignedSource<<88e31e7210e88db419bf5bd5913607a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePrintArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentShareWidgetContent">;
  readonly " $fragmentType": "articlePrintArticle";
};
export type articlePrintArticle$key = {
  readonly " $data"?: articlePrintArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePrintArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePrintArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "ccb520d423a9ad67e5b3906469176204";

export default node;
